import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';
import { fmtDateTime } from '../../../../utils/fmt';

const LoginActivityList = () => {
  const columns = [
    { label: 'User', value: 'user' },
    { label: 'Ip Address', value: 'ip_address' },
    { label: 'Timestamp', value: (item) => fmtDateTime(item.timestamp) },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];

  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/security/login-activity/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['loginActivity']} />;
};

export default LoginActivityList;